<template>
<div class="container">
  <Header />
  <b-row>
    <div v-if="isMatchFormVisible==false" class="mx-auto">
      <b-button variant="success" class="my-2" @click="setMeibo()" v-b-toggle.matches><font-awesome-icon size="lg" :icon="['fas','pencil-alt']" /> 記録を入力</b-button>
    </div>
    <div v-else class="mx-auto">
      <b-button variant="success" class="my-2" v-b-toggle.matches>入力欄を閉じる</b-button>
    </div>
  </b-row>
  <b-collapse id="matches" v-model="isMatchFormVisible">
    <b-tabs>
      <b-tab active title="1試合だけ入力">
        <MatchForm :meibo="meibo" inputType="single"/>
      </b-tab>
      <b-tab title="まとめて入力">
        <MatchForm :meibo="meibo" inputType="multi"/>
      </b-tab>
    </b-tabs>
  </b-collapse>
  <hr>
  <div class="pc">
    <validation-observer ref="obs" v-slot="ObserverProps">
      <b-form inline style="padding-right:1.25rem">
        <label class="mx-2 searchLabel">開始日</label>
        <validation-provider name="field1" rules="required|compareStartDateAndEndDate:field2">
          <b-form-datepicker name="field1" v-model="searchParam.startDate" lacale="ja" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"></b-form-datepicker>
        </validation-provider>
        <p class="mx-1"></p>
        <label class="mx-2 searchLabel">終了日</label>
        <validation-provider vid="field2" name="field2" rules="required">
          <b-form-datepicker name="field2" v-model="searchParam.endDate" lacale="ja" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"></b-form-datepicker>
        </validation-provider>
        <label class="mx-2 searchLabel">名前</label>
        <b-form-input name="playerName" v-model="searchParam.playerName" style="width:100px"></b-form-input>
        <b-button variant="success" class="my-2 searchButton" size="sm" @click="search" :disabled="ObserverProps.invalid" autocomplete="off">絞り込み</b-button>
      </b-form>
    </validation-observer>
  </div>
  <div class="mb">
    <validation-observer ref="obs" v-slot="ObserverProps">
      <b-row>
        <b-col class="col-6" style="padding:1px">
          <validation-provider name="field1" rules="required|compareStartDateAndEndDate:field2">
            <div class="text-center">開始日</div>
            <b-form-datepicker name="field1" v-model="searchParam.startDate" lacale="ja" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"></b-form-datepicker>
          </validation-provider>
        </b-col>
        <b-col class="col-6" style="padding:1px">
          <validation-provider vid="field2" name="field2" rules="required">
            <div class="text-center">終了日</div>
            <b-form-datepicker name="field2" v-model="searchParam.endDate" lacale="ja" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"></b-form-datepicker>
          </validation-provider>
        </b-col>
        <b-col class="col-12" style="padding:1px">
          <div class="text-center">名前</div>
          <b-form-input name="playerName" v-model="searchParam.playerName"></b-form-input>
        </b-col>
      </b-row>
      <div class="text-right">
        <b-button variant="success" class="mx-2 my-1" size="sm" @click="search" :disabled="ObserverProps.invalid">絞り込み</b-button>
      </div>
    </validation-observer>
  </div>
  <!-- <div style="padding-right:1.25rem" class="text-right">
    <b-button variant="success" class="my-2 mx-2" v-b-toggle.matches size="sm">対戦記録を入力</b-button>
  </div> -->
  <b-modal v-bind:id="'edit'" hide-header hide-footer modal-center>
    <Record :record="this.focusRecord"/>
  </b-modal>

  <div>
    {{message}}
  </div>
  <div v-for="(dataRound,index) in recordList" :key="index">
    <div v-for="(contentOfDataRound,index2) in dataRound" :key="index2">
      <div v-if="index2==='dataList'">
        <!-- setFocusRecordは()がついていると動かない。セミコロンで後続のメソッドを動かすのもダメなのでモーダルの表示はsetFocusRecordの中で行う。 -->
        <b-table striped bordered hover :items="contentOfDataRound" :fields="fields" caption-top @row-clicked="setFocusRecord">
          <template #table-caption class="text-danger">
              <div v-if="index>0&&recordList[index].date==recordList[index-1].date">
                <template v-if="index>0&&recordList[index].round!=recordList[index-1].round">
                  {{dataRound.round}}回戦
                  <b-row>
                    <b-col class="my-auto">
                      <div v-for="(contentOfReadPlaceInfo, index3) in dataRound.readPlaceInfo" :key="index3" >
                        <template>
                          <div style="font-size:14px;">
                            <b>会場{{index3+1}}：</b>{{contentOfReadPlaceInfo.place}}&#9;<b>{{contentOfReadPlaceInfo.readMode}}：</b>{{contentOfReadPlaceInfo.reader}}<br>
                          </div>
                        </template>
                      </div>

                    </b-col>
                  </b-row>
                </template>
                <b-row>
                  <b-col align-self="end" class="text-right" v-if="index>0&&recordList[index].round!=recordList[index-1].round">
                    <b-button class="mt-1 mb-3" size="sm" variant="success" @click="setMeibo();$bvModal.show('editPlaceAndReader');setParamsOfPlaceAndReaderModal(-recordList[index].date,dataRound.round, dataRound.readPlaceInfo)">会場・読手を更新</b-button>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="text-center">
                    <div style="font-size:16px;" class="text-middle">
                      <b>
                        <div v-if="dataRound.practiceType=='beginner' || dataRound.practiceType=='experienced'">
                          {{dataRound.practiceType|showPracticeType}}
                        </div>
                        <div v-else-if="index>0&&recordList[index].round==recordList[index-1].round">
                          未分類の練習
                        </div>
                      </b>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <div v-else>
                <hr>
                <div>{{dataRound.date|unixtimeToDate}}</div>
                <div>{{dataRound.round}}回戦</div>
                <b-row>
                  <b-col class="my-auto">
                    <div v-for="(contentOfReadPlaceInfo, index3) in dataRound.readPlaceInfo" :key="index3" >
                      <template>
                        <div style="font-size:14px;">
                          <b>会場{{index3+1}}：</b>{{contentOfReadPlaceInfo.place}}&#9;<b>{{contentOfReadPlaceInfo.readMode}}：</b>{{contentOfReadPlaceInfo.reader}}<br>
                        </div>
                      </template>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col align-self="end" class="text-right">
                    <b-button class="mt-1 mb-3" size="sm" variant="success" @click="setMeibo();$bvModal.show('editPlaceAndReader');setParamsOfPlaceAndReaderModal(-recordList[index].date, dataRound.round, dataRound.readPlaceInfo)">会場・読手を更新</b-button>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="text-center">
                    <div v-if="dataRound.practiceType=='beginner' || dataRound.practiceType=='experienced'" class="text-middle">
                      <div style="font-size:16px;"><b>{{dataRound.practiceType|showPracticeType}}</b></div>
                    </div>
                  </b-col>
                </b-row>
              </div>
          </template>
          <template v-slot:[`cell(player1Name)`]="data">
            <div class="text-center">
              <div v-if="data.item.player1Uid==''">{{data.item.player1Name}}
                <font-awesome-icon size="sm" :icon="['fas','user-alt-slash']" />
              </div>
              <div v-else>{{data.item.player1Name}}</div>
            </div>
          </template>
          <template v-slot:[`cell(player2Name)`]="data">
            <div class="text-center">
              <div v-if="data.item.player2Uid==''">{{data.item.player2Name}}
                <font-awesome-icon size="sm" :icon="['fas','user-alt-slash']" />
              </div>
              <div v-else>{{data.item.player2Name}}</div>
            </div>
          </template>
        </b-table>
      </div>
    </div>
  </div>
  <b-modal v-bind:id="'editPlaceAndReader'" hide-header hide-footer modal-center>
    <div v-if="readPlaceArrayOfPlaceAndReaderModal.length>=1">
      <b-row class="p-0">
        <b-col class="p-0">
          <label class="mx-2">会場</label>
        </b-col>
        <b-col class="p-0">
          <label class="mx-2">読み形式</label>
        </b-col>
        <b-col class="p-0">
          <label class="mx-2">読手(または操作者)</label>
        </b-col>
      </b-row>
    </div>
    <div v-for="placeAndReader in readPlaceArrayOfPlaceAndReaderModal" :key="placeAndReader.index">
      <b-row class="p-0">
        <b-col class="p-0">
          <b-form-input v-model="placeAndReader.place" placeholder="会場"></b-form-input>
        </b-col>
        <b-col class="p-0">
          <b-form-select v-model="placeAndReader.readMode" placeholder="読み形式" :options="readModeOptions"></b-form-select>
        </b-col>
        <b-col class="p-0">
          <b-form-input v-model="placeAndReader.reader" placeholder="読手" list="meibo"></b-form-input>
          <datalist id="meibo">
            <option v-for="member in meibo" :key="member">{{member}}</option>
          </datalist>
        </b-col>
      </b-row>
    </div>
    <div class="text-right">
      <b-button class="my-2 mx-2" variant="outline-success" @click="addMatchToMatchList()" size="sm">行を追加</b-button>
      <b-button class="my-2 mx-2" size="sm" variant="success" @click="updatePlaceAndReader(minusUnixTimeOfPlaceAndReaderModal,roundOfPlaceAndReaderModal,readPlaceArrayOfPlaceAndReaderModal);$bvModal.hide('editPlaceAndReader')">更新</b-button>
    </div>
    <p style="font-size:14px">※ある行を削除したい場合は、その行の内容を全部空白にして更新してください。</p>
  </b-modal>
</div>
</template>
<style :scope>
.searchButton {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important
}

label.searchLabel {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

@media screen and (max-width: 574px) {
  .searchButton {
    margin-left: auto !important
  }

  label.searchLabel {
    margin-top: 0.5rem !important;
    margin-bottom: 0.0rem !important;
  }
}

/*PCの場合*/
.pc {
  display: inline !important;
}

.mb {
  display: none !important;
}

@media screen and (max-width: 768px) {

  /*タブレット、スマホの場合*/
  .pc {
    display: none !important;
  }

  .mb {
    display: inline !important;
  }

  .container {
    margin-bottom: 64px;
  }
}

.vdp-datepicker__calendar {
  width: auto !important;
}

.table th, .table td {
  padding: 0.25rem;
}

.table td.records-name {
  width: 30%;
}

.table td.records-result {
  width: 13%;
}

.table td.records-cardNumber {
  width: 14%;
}

.modal-content {
  top: auto
}
</style>
<script>
import Header from '../components/Header.vue'
import MatchForm from '@/components/MatchForm.vue'
import Record from '../components/Record.vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import {
  ja
} from 'vuejs-datepicker/dist/locale';
import 'dayjs/locale/ja'
import dayjs from 'dayjs'
import {
  ValidationProvider,
  extend
} from "vee-validate";
import {
  required
} from "vee-validate/dist/rules";
extend('required', required);
extend('compareStartDateAndEndDate', {
  params: [{
    name: 'str',
    isTarget: true
  }],
  validate(value, {
    str
  }) {
    // 空チェック
    if (!value || !str) return false
    // 大小チェック
    if (value > str) return false
    return true
  }
});

export default {
  name: 'Records',
  components: {
    Header,
    MatchForm,
    Record,
    ValidationProvider,
  },
  filters: {
    unixtimeToDate: function(unixtime) {
      return dayjs(unixtime * 1000).format('YYYY/MM/DD');
    },
    showPracticeType: function(practiceType){
      if(practiceType == "beginner"){
        return "初心者練";
      }else if(practiceType == "experienced"){
        return "経験者練";
      }else if(practiceType == "uncategorized"){
        return ;
      }else{
        console.log("知らないpracticeType"+practiceType);
      }
    }
  },
  data() {
    return {
      matchList: [],
      result: {
        date: dayjs(new Date()).format('YYYY-MM-DD'),
        player1Name: "",
        player2Name: "",
        player1Result: "",
        player2Result: "",
        cardNumber: "",
      },
      resultOptions: [{
          value: "",
          text: ''
        },
        {
          value: 1,
          text: '勝ち'
        },
        {
          value: 0,
          text: '負け'
        },
      ],
      userStatus: {},
      authorized: false,
      form: {
        name: "",
      },
      ja: ja,
      recordList: [],
      readPlaceList: [],
      readModeOptions:[
        "",
        "読み",
        "ありあけ(西田)",
        "ありあけ(和家)",
        "ありあけ(吉川)",
        "ありあけ(稲葉)",
        "ありあけ(廣本)",
        "ありあけ(楠田)",
        "ありあけ(芹野)",
        "ありあけ(山下)",
        "ありあけ(五味)",
        "わすらもち"
      ],
      placeAndReaderList:[],
      numberOfRecords:0,
      fields: [{
          key: "player1Name",
          label: "名前",
          thClass: "text-center",
          tdClass: "text-center records-name"
        },
        {
          key: "player1Result",
          label: "勝敗",
          formatter: "numberToSymbol",
          thClass: "text-center",
          tdClass: "text-center records-result"
        },
        {
          key: "cardNumber",
          label: "枚数",
          thClass: "text-center",
          tdClass: "text-center records-cardNumber"
        },
        {
          key: "player2Result",
          label: "勝敗",
          formatter: "numberToSymbol",
          thClass: "text-center",
          tdClass: "text-center records-result"
        },
        {
          key: "player2Name",
          label: "名前",
          thClass: "text-center",
          tdClass: "text-center records-name"
        },
      ],
      readPlaceFields:[{
          key: "date",
          label: "日付",
          thClass: "text-center",
          tdClass: "text-center records-name"
        },
        {
          key: "round",
          label: "回戦",
          formatter: "numberToSymbol",
          thClass: "text-center",
          tdClass: "text-center records-result"
        },
        {
          key: "readMode",
          label: "読み/ありあけ",
          thClass: "text-center",
          tdClass: "text-center records-cardNumber"
        },
        {
          key: "reader",
          label: "読み/押し",
          thClass: "text-center",
          tdClass: "text-center records-result"
        },
        {
          key: "place",
          label: "会場",
          thClass: "text-center",
          tdClass: "text-center records-name"
        },
      ],
      user: firebase.auth().currentUser,
      uid: firebase.auth().currentUser.uid,
      currentPage: 1,
      message: "",
      focusRecord: {},
      searchParam: {
        startDate: dayjs(dayjs().subtract(2, 'week')).format("YYYY-MM-DD"),
        endDate: dayjs().format("YYYY-MM-DD"),
        playerName: "",
      },
      matchFormList:[1],
      minusUnixTimeOfPlaceAndReaderModal:new Number(),
      roundOfPlaceAndReaderModal:new Number(),
      readPlaceArrayOfPlaceAndReaderModal: [],
      meibo: [],
      isMatchFormVisible: false,
    }
  },
  beforeCreate() {},
  created: function() {
    this.database = firebase.database();
    this.uid = firebase.auth().currentUser.uid;
    this.search();
  },
  methods: {
    search() {
      let startDate = dayjs(this.searchParam.startDate)
      let endDate = dayjs(this.searchParam.endDate)
      let observe = this.database.ref("records/");
      var _this = this;
      this.message = "";
      observe.on('value', function() {
        // observerの中に、observerに対してクエリを負荷したもの（queryRef）を定義することで、records以下に変更があった場合はqueryRefに限定してデータを取得するようにする
        // このようにしないと、範囲指定検索した状態で、他の人がデータを投稿すると範囲指定が解除され全てのデータが表示される事象が起こる
        let queryRef = observe.orderByKey().startAt(String(-endDate / 1000)).endAt(String(-startDate / 1000))
        queryRef.on("value", function(querySnapshot) {console.log(querySnapshot.val());
          _this.recordList = [];
          var hashData = querySnapshot.val();
          if (!querySnapshot.val()) { //デフォルトの2週間では記録がないこともあるかも。errorが出て腹立つので
            _this.message = "練習記録が存在しないようです。期間を変更してみてください。";
            return;
          }
          var dateListReversed = Object.keys(hashData);
          dateListReversed.forEach(function(child) {
            var hiduke = -child;
            if (typeof(hashData[child]) === 'object') {
              // _this.searchParam.playerName
              for (let round in hashData[child]) {
                let recordsOfDateAndRoundBeginner = {}
                recordsOfDateAndRoundBeginner["date"] = hiduke;
                recordsOfDateAndRoundBeginner["round"] = round;
                recordsOfDateAndRoundBeginner["practiceType"] = "beginner";
                recordsOfDateAndRoundBeginner["dataList"] = [];
                let recordsOfDateAndRoundExperienced = {}
                recordsOfDateAndRoundExperienced["date"] = hiduke;
                recordsOfDateAndRoundExperienced["round"] = round;
                recordsOfDateAndRoundExperienced["practiceType"] = "experienced";
                recordsOfDateAndRoundExperienced["dataList"] = [];
                let recordsOfDateAndRoundUncategorized = {}
                recordsOfDateAndRoundUncategorized["date"] = hiduke;
                recordsOfDateAndRoundUncategorized["round"] = round;
                recordsOfDateAndRoundUncategorized["practiceType"] = "uncategorized";
                recordsOfDateAndRoundUncategorized["dataList"] = [];
                let records = (hashData[child])[round]
                for (const [key, value] of Object.entries(records)) {
                  if(key == "placeInfo"){
                    recordsOfDateAndRoundBeginner["readPlaceInfo"] = [];
                    recordsOfDateAndRoundExperienced["readPlaceInfo"] = [];
                    recordsOfDateAndRoundUncategorized["readPlaceInfo"] = [];
                    Object.keys(value).forEach(function(element){
                      let readMode = value[element]["readMode"];
                      let reader = value[element]["reader"];
                      if(!reader){
                        reader = "記載なし";
                      }
                      let place = value[element]["place"];
                      if(!place){
                       place = "記載なし";
                      }
                      recordsOfDateAndRoundBeginner["readPlaceInfo"].push({"date":hiduke, "round":round, "readMode":readMode, "reader":reader, "place":place});
                      recordsOfDateAndRoundExperienced["readPlaceInfo"].push({"date":hiduke, "round":round, "readMode":readMode, "reader":reader, "place":place});
                      recordsOfDateAndRoundUncategorized["readPlaceInfo"].push({"date":hiduke, "round":round, "readMode":readMode, "reader":reader, "place":place});
                    })
                  } else {
                    value["key"] = key;
                    if(_this.searchParam.playerName == ""){
                      if(value.practiceType == "beginner"){
                        recordsOfDateAndRoundBeginner["dataList"].push(value);
                      }else if(value.practiceType == "experienced"){
                        recordsOfDateAndRoundExperienced["dataList"].push(value);
                      }else if(value.practiceType == undefined || value.practiceType == "uncategorized"){
                        recordsOfDateAndRoundUncategorized["dataList"].push(value);
                      }else {console.log(value.practiceType+"ってどこ？！"+value.date)}
                    } else {
                      if(value.player1Name.includes(_this.searchParam.playerName) || value.player2Name.includes(_this.searchParam.playerName)){ 
                        if(value.practiceType == "beginner"){
                          recordsOfDateAndRoundBeginner["dataList"].push(value);
                        }else if(value.practiceType == "experienced"){
                          recordsOfDateAndRoundExperienced["dataList"].push(value);
                        }else if(value.practiceType == undefined || value.practiceType == "uncategorized"){
                          recordsOfDateAndRoundUncategorized["dataList"].push(value);
                        }else {console.log(value.practiceType+"ってどこ？！"+value.date)}
                      }
                    }
                  }
                }
                if(recordsOfDateAndRoundBeginner.dataList.length> 0) _this.recordList.push(recordsOfDateAndRoundBeginner);
                if(recordsOfDateAndRoundExperienced.dataList.length> 0) _this.recordList.push(recordsOfDateAndRoundExperienced);
                if(recordsOfDateAndRoundUncategorized.dataList.length> 0) _this.recordList.push(recordsOfDateAndRoundUncategorized);
              }
            } else {
              hashData[child].forEach(function(e, round) {
                let recordsOfDateAndRoundBeginner = {}
                recordsOfDateAndRoundBeginner["date"] = hiduke;
                recordsOfDateAndRoundBeginner["round"] = round;
                recordsOfDateAndRoundBeginner["practiceType"] = "beginner";
                recordsOfDateAndRoundBeginner["dataList"] = [];
                let recordsOfDateAndRoundExperienced = {}
                recordsOfDateAndRoundExperienced["date"] = hiduke;
                recordsOfDateAndRoundExperienced["round"] = round;
                recordsOfDateAndRoundExperienced["practiceType"] = "experienced";
                recordsOfDateAndRoundExperienced["dataList"] = [];
                let recordsOfDateAndRoundUncategorized = {}
                recordsOfDateAndRoundUncategorized["date"] = hiduke;
                recordsOfDateAndRoundUncategorized["round"] = round;
                recordsOfDateAndRoundUncategorized["practiceType"] = "uncategorized";
                recordsOfDateAndRoundUncategorized["dataList"] = [];
                for (const [key, value] of Object.entries(e)) {
                  if(key == "placeinfo"){
                    recordsOfDateAndRoundBeginner["readPlaceInfo"] = [];
                    recordsOfDateAndRoundExperienced["readPlaceInfo"] = [];
                    recordsOfDateAndRoundUncategorized["readPlaceInfo"] = [];
                    Object.keys(value).forEach(function(element){
                      let readMode = value[element]["readMode"];
                      let reader = value[element]["reader"];
                      let place = value[element]["place"];
                      recordsOfDateAndRoundBeginner["readPlaceInfo"].push({"date":hiduke, "round":round, "readMode":readMode, "reader":reader, "place":place});
                      recordsOfDateAndRoundExperienced["readPlaceInfo"].push({"date":hiduke, "round":round, "readMode":readMode, "reader":reader, "place":place});
                      recordsOfDateAndRoundUncategorized["readPlaceInfo"].push({"date":hiduke, "round":round, "readMode":readMode, "reader":reader, "place":place});
                    })
                  } else {
                    value["key"] = key;
                    if(_this.searchParam.playerName == ""){
                      if(value.practiceType == "beginner"){
                        recordsOfDateAndRoundBeginner["dataList"].push(value);
                      }else if(value.practiceType == "experienced"){
                        recordsOfDateAndRoundExperienced["dataList"].push(value);
                      }else if(value.practiceType == undefined || value.practiceType == "uncategorized"){
                        recordsOfDateAndRoundUncategorized["dataList"].push(value);
                      }else {console.log(value.practiceType+"ってどこ？！"+value.date)}
                    } else {
                      if(value.player1Name.includes(_this.searchParam.playerName) || value.player2Name.includes(_this.searchParam.playerName)){
                        if(value.practiceType == "beginner"){
                          recordsOfDateAndRoundBeginner["dataList"].push(value);
                        }else if(value.practiceType == "experienced"){
                          recordsOfDateAndRoundExperienced["dataList"].push(value);
                        }else if(value.practiceType == undefined || value.practiceType == "uncategorized"){
                          recordsOfDateAndRoundUncategorized["dataList"].push(value);
                        }else {console.log(value.practiceType+"ってどこ？！"+value.date)}
                      }
                    }
                  }
                }
                if(recordsOfDateAndRoundBeginner.dataList.length> 0) _this.recordList.push(recordsOfDateAndRoundBeginner);
                if(recordsOfDateAndRoundExperienced.dataList.length> 0) _this.recordList.push(recordsOfDateAndRoundExperienced);
                if(recordsOfDateAndRoundUncategorized.dataList.length> 0) _this.recordList.push(recordsOfDateAndRoundUncategorized);
              });
            }
          })
        });
      });
    },
    setResult(player) {
      if (player == "player2") {
        if (this.result.player1Result == null) {
          this.result.player2Result = null;
        } else {
          this.result.player2Result = !this.result.player1Result
        }
      } else {
        if (this.result.player2Result == null) {
          this.result.player1Result = null;
        } else {
          this.result.player1Result = !this.result.player2Result
        }
      }
    },
    numberToSymbol(num) {
      switch(num) {
        case 1:
          return "○"
        case 0:
          return "×"
        case -1:
          return "指導"
        case "":
          return ""
      }
    },
    conversion(date) {
      if (date == '') {
        return ''
      } else {
        var date2 = new Date(date)

        return dayjs(date2).format("YYYY/MM/DD")
      }
    },
    addResultToResultList() {
      const result = {
        date: dayjs(new Date()).format('YYYY-MM-DD'),
        player1Name: "",
        player2Name: "",
        player1Result: "",
        player2Result: "",
        cardNumber: "",
      }
      this.matchList.push(result);
    },
    submit() {
      firebase.database().ref('records/' + this.uid + '/oldGoal').push()
      this.oldGoal.goalType = ""
      this.oldGoal.startDate = ""
      this.oldGoal.endDate = ""
      this.oldGoal.content = ""
      this.oldGoal.evaluation = ""
      this.oldGoal.feedback = ""
      this.$bvModal.hide('submitOldGoal')
    },
    moveToDetail(record) {
      let date = dayjs(record.date);
      let dateKey = -date.unix();
      let round = record.round
      this.$router.push({
        name: 'recordDetail',
        query: {
          dateKey: dateKey,
          round: round,
          key: record.key
        }
      })
    },
    setFocusRecord(record) {
      this.setMeibo()
      this.focusRecord = record;
      this.$bvModal.show('edit');
    },
    addNewMatchForm(){
      this.matchFormList.push(this.matchFormList.length);
    },
    setParamsOfPlaceAndReaderModal(minusUnixTime, round, readPlaceInfo){
      this.minusUnixTimeOfPlaceAndReaderModal = minusUnixTime;
      this.roundOfPlaceAndReaderModal = round;
      this.readPlaceArrayOfPlaceAndReaderModal = [];
      for(let index in readPlaceInfo) {
        this.readPlaceArrayOfPlaceAndReaderModal.push({
          "place": readPlaceInfo[index].place,
          "readMode": readPlaceInfo[index].readMode,
          "reader": readPlaceInfo[index].reader,
        })
      }
    },
    updatePlaceAndReader(minusUnixTimeOfPlaceAndReaderModal,roundOfPlaceAndReaderModal,readPlaceArrayOfPlaceAndReaderModal){
      let placeAndReaderRef = firebase.database().ref('records/'+minusUnixTimeOfPlaceAndReaderModal+'/'+roundOfPlaceAndReaderModal+'/placeInfo');
      placeAndReaderRef.remove()
      let placeAndReaderObj = new Object();
      for(let i in readPlaceArrayOfPlaceAndReaderModal){
        let placeAndReaderInfo = readPlaceArrayOfPlaceAndReaderModal[i]
        if(placeAndReaderInfo.place == "" && placeAndReaderInfo.readMode == "" && placeAndReaderInfo.reader == "") continue;
        placeAndReaderObj[i] = placeAndReaderInfo;
      }
      placeAndReaderRef.update(placeAndReaderObj);
    },
    addMatchToMatchList() {
      //対戦組合せリストに1行追加する
      const result = {
        "place": "",
        "readMode": "",
        "reader": "",
      }
     this.readPlaceArrayOfPlaceAndReaderModal.push(result);
    },
    setMeibo(){
      let meiboHash = new Object();
      firebase.database().ref('meibo/').on("value", snapShot => {
        if (snapShot) {
          snapShot.forEach((data) => {
            let meiboMemberByYear = data.val();
            for(let member in meiboMemberByYear){
              meiboMemberByYear[member]['year'] = data.key
            }
            meiboHash = Object.assign(meiboHash, meiboMemberByYear)
          });
        }
      })
      this.meibo = Object.keys(this.sortMeiboHash(meiboHash));
    },
    sortMeiboHash(meiboHash) {
      let meiboArray = new Array();
      for (let person in meiboHash) {
        let kana = meiboHash[person].kana
        let personObj = {
          "kana": kana,
          "name": person,
          "value": meiboHash[person]
        }
        meiboArray.push(personObj)
      }
      meiboArray.sort(function(a, b) {
        if (a.kana < b.kana) {
          return -1;
        } else {
          return 1;
        }
      });
      let meiboObj = new Object();
      for (let i in meiboArray) {
        meiboObj[meiboArray[i].name] = meiboArray[i].value
      }
      return meiboObj;
    },
  },
}
</script>
